import { defineMessages } from 'react-intl';

export default defineMessages({
    AddBusinessActivityPopupIncidental: {
        id: 'common.views.ml-pup-add-business-activity.Excess Incidental Occupancy',
        defaultMessage: 'Excess Incidental Occupancy'
    },
    AddBusinessActivityPopupBusiness: {
        id: 'common.views.ml-pup-add-business-activity.Excess Business Pursuits',
        defaultMessage: 'Excess Business Pursuits'
    },
    AddBusinessActivityPopupBusinessQuestionsetHeader: {
        id: 'common.views.ml-pup-add-business-activity.Questionset Header',
        defaultMessage: 'Business Questions'
    },
    RequiredQuestion: {
        id: 'common.views.ml-pup-add-business-activity.Required Questions',
        defaultMessage: 'This is required'
    },
    BusinessDescriptionLabel: {
        id: 'common.views.ml-pup-add-business-activity.Description of Business',
        defaultMessage: 'Description of Business'
    },
    BusinessTypeLabel: {
        id: 'common.views.ml-pup-add-business-activity.Business Type',
        defaultMessage: 'Business Type'
    },
    CoverageTypeLabel: {
        id: 'common.views.ml-pup-add-business-activity.Coverage Type',
        defaultMessage: 'Coverage Type'
    },
    CoverageTypeTooltipLabel: {
        id: 'common.views.ml-pup-add-business-activity.helpTextTitle.businessClass.Which coverage type should I select?',
        defaultMessage: 'Which coverage type should I select?'
    },
    CoverageTypeTooltipContent: {
        id: 'common.views.ml-pup-add-business-activity.helpText.businessClass.Business Class Tooltip Content',
        defaultMessage: '<p>Excess Business pursuits – provides liability coverage for business conducted away from your residence.  It provides coverage for an insured who is an employee of someone else.</p><p>Excess Incidental Occupancies – provides liability coverage for the described business which is conducted at or from your residence.</p>'
    },
    NameOfBusinessLabel: {
        id: 'common.views.ml-pup-add-business-activity.Name of Business',
        defaultMessage: 'Name of Business'
    },
    UnderlyingPolicyLabel: {
        id: 'common.views.ml-pup-add-business-activity.Underlying Policy',
        defaultMessage: 'Underlying Policy'
    },
    MyPolicyInfoLabel:{
        id:'common.views.ml-pup-add-business-activity.My Policy Info',
        defaultMessage: 'My Policy Info'
    },
    BusinessTypeTooltipContent: {
        id: 'common.views.ml-pup-add-business-activity.BusinessActivity help message',
        defaultMessage: `<p>Excess Business pursuits – provides liability coverage for business conducted away from your residence. It provides coverage for an insured who is an employee of someone else.</p><br/>
        <p>Excess Incidental Occupancies – provides liability coverage for the described business which is conducted at or from your residence.</p>`
    },
    BusinessTypeTooltipContentForNP: {
        id: 'common.views.ml-pup-add-business-activity.BusinessActivity help message for NP',
        defaultMessage: `<p>Excess Business Pursuits Liability Insured as Employee - Provides bodily injury and property damage for the business pursuits of the insured for the business listed on the Declarations. Must have underlying coverage.</p><br/>
        <p>Excess Child Care Liability – Provides bodily injury and property damage in the event you have a home day care business. Must have underlying coverage.</p><br/>
        <p>Excess Home Business Coverage - Provides bodily injury, personal injury and property damage for the business listed on the Declarations. Designated business may be conducted on or off premises but must be a business of the insured and does not involve or consist of any home care services. Must have underlying coverage.</p>`
    },
});
